import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import BrandsCarousel from '../../Slider/BrandsCarousel';

export default function BrandsSectionStyle2({ data, sectionTitle }) {
  return (
    <div className="container">
      {sectionTitle && (
        <>
          <SectionHeading title={sectionTitle} center />
          <Spacing md="72" lg="50" />
        </>
      )}
      <BrandsCarousel data={data} />
    </div>
  );
}